import { Point } from "./Point";
/**
 * Find mouse position in canvas coordinate system.
 * @param canvas Creator canvas element
 * @param evt Mouse click event
 */
export function getMousePos(canvas: HTMLCanvasElement, evt: MouseEvent): Point {
    var rect = canvas.getBoundingClientRect();
    return {
        x: evt.clientX - rect.left,
        y: evt.clientY - rect.top
    };
}
/**
 * Convert canvas coordinates of point to document coordinates.
 * @param canvas Creator canvas element
 * @param pos Canvas coordinates
 */
export function getAbsolutePos(canvas: HTMLCanvasElement, pos: Point): Point {
    var rect = canvas.getBoundingClientRect();
    return {
        x: rect.left + pos.x,
        y: rect.top + pos.y
    };
}
